export const COLORS = {
  TRANSPARENT: 'transparent',
  WHITE_VARIANT: '#ffffff',

  ACCENTUATED_VARIANT: '#41a152',
  ACCENTUATED_VARIANT_DARK: '#276131',

  PRIMARY_VARIANT: '#4b4b4b',
  PRIMARY_VARIANT_DARK: '#202124',

  SECONDARY_VARIANT: '#f4f4f4',
  SECONDARY_VARIANT_MEDIUM: '#e1e1e1',
  SECONDARY_VARIANT_DARK: '#bcbcbc',

  ALERT_POSITIVE: '#66c39b',
  ALERT_NEGATIVE: '#c9252d',
  ALERT_ALERT: '#ff9900',
  ALERT_SECONDARY: '#fad368ff',
  ALERT_INFORMATIVE: '#2c7dd9',
  ALERT_HOVER: '#EDF9F0',

  VARIANTE: '#bcbcbc',
  NEGATIVE_VARIANT: '#c9252d',
  FILTER_BORDER: '#bcbcbc',

  ALERT_NEGATIVE_DARK: '#a31d24'
};
